(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mini-wakit-women-landing"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  if (typeof gsap === "undefined") return;

  // ==========================
  // Hero Animation
  // ==========================
  var heroLines = document.querySelectorAll(".wk-h1-line > span");

  if (heroLines.length) {
    gsap.from(heroLines, {
      y: "110%",
      opacity: 0,
      duration: 1,
      stagger: 0.18,
      ease: "expo.out",
      delay: 0.3
    });
  }

    // ==========================
  // Pill Dot Blink
  // ==========================
  var pillDot = document.querySelector(".wk-pill__dot");

  if (pillDot) {
    gsap.to(pillDot, {
      scale: 0.55,
      opacity: 0.35,
      duration: 0.65,
      ease: "power1.inOut",
      repeat: -1,
      yoyo: true,
      transformOrigin: "center center"
    });
  }

  // ==========================
  // Premium Testimonial Carousel
  // ==========================
  var cards = gsap.utils.toArray(".wk-testimonial__carousel .wk-testimonial__card");

  if (cards.length < 2) return;

  var current = 0;

  gsap.set(cards, {
    position: "absolute",
    inset: 0,
    autoAlpha: 0,
    x: 40,
    zIndex: 1
  });

  gsap.set(cards[0], {
    autoAlpha: 1,
    x: 0,
    zIndex: 2
  });

  setInterval(function () {
    var oldCard = cards[current];

    current = (current + 1) % cards.length;

    var newCard = cards[current];

    gsap.set(newCard, {
      zIndex: 2
    });

    gsap.set(oldCard, {
      zIndex: 1
    });

    gsap.to(oldCard, {
      autoAlpha: 0,
      x: -40,
      duration: 0.5,
      ease: "power2.inOut"
    });

    gsap.fromTo(
      newCard,
      {
        autoAlpha: 0,
        x: 40
      },
      {
        autoAlpha: 1,
        x: 0,
        duration: 0.5,
        ease: "power2.inOut"
      }
    );

  }, 5000);

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  function initProductGallery() {
    const mainImage = document.getElementById('product-main-image');
    const thumbnails = document.querySelectorAll('.product-gallery__thumbnail');

    if (!mainImage || thumbnails.length === 0) return;

    thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', function() {
        // Update main image
        const imageUrl = this.getAttribute('data-image-url');
        const imageSrcset = this.getAttribute('data-image-srcset');
        const imageAlt = this.getAttribute('data-image-alt');

        mainImage.src = imageUrl;
        mainImage.srcset = imageSrcset;
        mainImage.alt = imageAlt;

        // Update active state
        thumbnails.forEach(thumb => thumb.classList.remove('active'));
        this.classList.add('active');
      });
    });
  }

  // Initialize gallery when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductGallery);
  } else {
    initProductGallery();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wakit-landing-3g-men"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  if (typeof gsap === "undefined") return;

  // ==========================
  // Hero Animation
  // ==========================
  var heroLines = document.querySelectorAll(".wk-h1-line > span");

  if (heroLines.length) {
    gsap.from(heroLines, {
      y: "110%",
      opacity: 0,
      duration: 1,
      stagger: 0.18,
      ease: "expo.out",
      delay: 0.3
    });
  }

    // ==========================
  // Pill Dot Blink
  // ==========================
  var pillDot = document.querySelector(".wk-pill__dot");

  if (pillDot) {
    gsap.to(pillDot, {
      scale: 0.55,
      opacity: 0.35,
      duration: 0.65,
      ease: "power1.inOut",
      repeat: -1,
      yoyo: true,
      transformOrigin: "center center"
    });
  }

  // ==========================
  // Premium Testimonial Carousel
  // ==========================
  var cards = gsap.utils.toArray(".wk-testimonial__carousel .wk-testimonial__card");

  if (cards.length < 2) return;

  var current = 0;

  gsap.set(cards, {
    position: "absolute",
    inset: 0,
    autoAlpha: 0,
    x: 40,
    zIndex: 1
  });

  gsap.set(cards[0], {
    autoAlpha: 1,
    x: 0,
    zIndex: 2
  });

  setInterval(function () {
    var oldCard = cards[current];

    current = (current + 1) % cards.length;

    var newCard = cards[current];

    gsap.set(newCard, {
      zIndex: 2
    });

    gsap.set(oldCard, {
      zIndex: 1
    });

    gsap.to(oldCard, {
      autoAlpha: 0,
      x: -40,
      duration: 0.5,
      ease: "power2.inOut"
    });

    gsap.fromTo(
      newCard,
      {
        autoAlpha: 0,
        x: 40
      },
      {
        autoAlpha: 1,
        x: 0,
        duration: 0.5,
        ease: "power2.inOut"
      }
    );

  }, 5000);

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wakit-landing-mini-men"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  if (typeof gsap === "undefined") return;

  // ==========================
  // Hero Animation
  // ==========================
  var heroLines = document.querySelectorAll(".wk-h1-line > span");

  if (heroLines.length) {
    gsap.from(heroLines, {
      y: "110%",
      opacity: 0,
      duration: 1,
      stagger: 0.18,
      ease: "expo.out",
      delay: 0.3
    });
  }

    // ==========================
  // Pill Dot Blink
  // ==========================
  var pillDot = document.querySelector(".wk-pill__dot");

  if (pillDot) {
    gsap.to(pillDot, {
      scale: 0.55,
      opacity: 0.35,
      duration: 0.65,
      ease: "power1.inOut",
      repeat: -1,
      yoyo: true,
      transformOrigin: "center center"
    });
  }

  // ==========================
  // Premium Testimonial Carousel
  // ==========================
  var cards = gsap.utils.toArray(".wk-testimonial__carousel .wk-testimonial__card");

  if (cards.length < 2) return;

  var current = 0;

  gsap.set(cards, {
    position: "absolute",
    inset: 0,
    autoAlpha: 0,
    x: 40,
    zIndex: 1
  });

  gsap.set(cards[0], {
    autoAlpha: 1,
    x: 0,
    zIndex: 2
  });

  setInterval(function () {
    var oldCard = cards[current];

    current = (current + 1) % cards.length;

    var newCard = cards[current];

    gsap.set(newCard, {
      zIndex: 2
    });

    gsap.set(oldCard, {
      zIndex: 1
    });

    gsap.to(oldCard, {
      autoAlpha: 0,
      x: -40,
      duration: 0.5,
      ease: "power2.inOut"
    });

    gsap.fromTo(
      newCard,
      {
        autoAlpha: 0,
        x: 40
      },
      {
        autoAlpha: 1,
        x: 0,
        duration: 0.5,
        ease: "power2.inOut"
      }
    );

  }, 5000);

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wakit-landing"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  if (typeof gsap === "undefined") return;

  // ==========================
  // Hero Animation
  // ==========================
  var heroLines = document.querySelectorAll(".wk-h1-line > span");

  if (heroLines.length) {
    gsap.from(heroLines, {
      y: "110%",
      opacity: 0,
      duration: 1,
      stagger: 0.18,
      ease: "expo.out",
      delay: 0.3
    });
  }

    // ==========================
  // Pill Dot Blink
  // ==========================
  var pillDot = document.querySelector(".wk-pill__dot");

  if (pillDot) {
    gsap.to(pillDot, {
      scale: 0.55,
      opacity: 0.35,
      duration: 0.65,
      ease: "power1.inOut",
      repeat: -1,
      yoyo: true,
      transformOrigin: "center center"
    });
  }

  // ==========================
  // Premium Testimonial Carousel
  // ==========================
  var cards = gsap.utils.toArray(".wk-testimonial__carousel .wk-testimonial__card");

  if (cards.length < 2) return;

  var current = 0;

  gsap.set(cards, {
    position: "absolute",
    inset: 0,
    autoAlpha: 0,
    x: 40,
    zIndex: 1
  });

  gsap.set(cards[0], {
    autoAlpha: 1,
    x: 0,
    zIndex: 2
  });

  setInterval(function () {
    var oldCard = cards[current];

    current = (current + 1) % cards.length;

    var newCard = cards[current];

    gsap.set(newCard, {
      zIndex: 2
    });

    gsap.set(oldCard, {
      zIndex: 1
    });

    gsap.to(oldCard, {
      autoAlpha: 0,
      x: -40,
      duration: 0.5,
      ease: "power2.inOut"
    });

    gsap.fromTo(
      newCard,
      {
        autoAlpha: 0,
        x: 40
      },
      {
        autoAlpha: 1,
        x: 0,
        duration: 0.5,
        ease: "power2.inOut"
      }
    );

  }, 5000);

});

  } catch(e) { console.error(e); }
})();
})();
